import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ButtonIcon from "../common/buttonIcon";
import SelectBox from "../common/selectBox";
import InputSearch from "./inputSearch";
import moment from "moment";

import { useAppDispatch } from "../../redux";
import {
  loadDatesWithTimeslot,
  loadDoctorDatesWithTimeslot,
  loadDoctorFilterPrenotations,
  loadDoctorPrenotationList,
  loadFilterPrenotations,
  loadPrenotationList,
  updatePage,
  updateSearch,
} from "../../redux/reducer/prenotationReducer";
import { useTranslation } from "react-i18next";
import {
  changeFilterType,
  loadCategoryDoctorTimeslot,
  loadCategoryTimeslot,
} from "../../redux/reducer/timeslotReducer";
import DatePickerInput from "../common/datePickerInput";
import AutoComplite from "../common/autoComplite";
import DropdownIcon from "../common/dropdownIcon";
import PopUpEmailSchedule from "../popUpEmailSchedule";
import PopUpLinkPublicCalendars from "../popUpLinkPublicCalendars";
import { hasModules } from "../../utils/helpers";
import PopUpLinkTelevisit from "../popUpLinkTelevisit";

const FilterBox = () => {
  const { t } = useTranslation();
  const { eventId, user } = useSelector((state: any) => state.login);
  const { prenotation } = useSelector((state: any) => state);

  // can be "list" or "calendar", used to switch between the two and to show/hide part of filters
  const { filterType } = useSelector((state: any) => state.timeslot);

  // left part of the filter is composed by 3 fields related each other, here where these values are stored
  // selected date in datepicker (shown only for filterType === "list")
  const [date, setDate] = useState("");
  // selected category in select box
  const [timeslotCategory, setTimeslotCategory] = useState("");
  // selected timeslot (shown only for filterType === "list")
  const [timeslotFilter, setTimeslotFilter] = useState("");
  const [timeslotOption, setTimeslotOption] = useState<null | any>(null);

  const [showPopUpEmailSchedule, setShowPopUpEmailSchedule] = useState(false);

  const [showPopUpLnkPublicCalendars, setShowPopUpLnkPublicCalendars] =
    useState(false);
  const [showPopUpLnkTelevisit, setShowPopUpLnkTelevisit] = useState(false);
  // values used for the 3 fields selection mentioned before
  // dates enabled in date selection
  let paramsDateSelect: any[] = prenotation.dateFilter
    .map((value: any) => value._id)
    .filter((params: any) => params !== undefined);
  // categories for the dropdown list, loaded by loadCategoryTimeslot
  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);
  let paramsCategory = categoryPrenotation.map((value: any) => [
    value.name,
    value._id,
  ]);
  let paramsDoctorCategory = categoryPrenotation.map((value: any) => [
    value.name,
    value.categorySlug,
  ]);
  // times for the timeslot dropdown
  let pramsTimeslot: any[] = prenotation.timeslotFilter.map((value: any) => {
    return {
      label:
        moment(value.startDate).format("HH:mm") +
        " - " +
        moment(value.endDate).format("HH:mm"),
      value: value._id,
    };
  });
  const emptyTimeslotOption = { value: "", label: "Seleziona" };
  pramsTimeslot = [emptyTimeslotOption].concat(pramsTimeslot);

  // text search on the right
  const [searchInput, setSearch] = useState("");

  const dispatch = useAppDispatch();
  const isDoctor = hasModules(user, "FEDERFARMA_DOCTOR");

  // load categories for the dropdown list, loaded into categoryPrenotation
  // load dates for datepicker
  // can be run only once after first render, not subject to updates during searches
  useEffect(() => {
    if (isDoctor) {
      dispatch(loadDoctorDatesWithTimeslot());
      dispatch(loadCategoryDoctorTimeslot());
    } else {
      dispatch(loadDatesWithTimeslot());
      dispatch(loadCategoryTimeslot());
    }
  }, [user]);

  // load timeslot only if both date and category are populated
  useEffect(() => {
    if (date && timeslotCategory) {
      setTimeslotFilter(emptyTimeslotOption.value);
      setTimeslotOption(emptyTimeslotOption);
      if (isDoctor) {
        dispatch(loadDoctorFilterPrenotations(date, timeslotCategory));
      } else {
        dispatch(loadFilterPrenotations(date, timeslotCategory));
      }
    }
  }, [date, timeslotCategory, user]);

  const onTimeslotOptionChange = (option: any) => {
    setTimeslotFilter(option.value);
    setTimeslotOption(option);
  };

  useEffect(() => {
    dispatch(
      updateSearch({
        date: date,
        timeslotFilter: timeslotFilter,
        eventId: eventId,
        searchInput: searchInput.trim(),
        timeslotCategory: timeslotCategory,
      })
    );
    dispatch(updatePage(1));

    if (isDoctor) {
      dispatch(loadDoctorPrenotationList());
    } else {
      dispatch(loadPrenotationList());
    }
  }, [date, timeslotCategory, timeslotFilter, searchInput, user]);

  return (
    <>
      <div className="Filter">
        <div className="row m-0">
          <div className="col-lg-8">
            {/* date selection */}
            {filterType === "list" ? (
              <>
                <DatePickerInput
                  handleChange={setDate}
                  dateSelected={
                    date
                      ? new Date(
                        moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                      )
                      : null
                  }
                  showDates={paramsDateSelect}
                  label="Data"
                  firstSelect="Seleziona"
                />
              </>
            ) : (
              <></>
            )}

            {/* category selection */}
            <SelectBox
              handleChange={setTimeslotCategory}
              value={timeslotCategory}
              params={
                isDoctor
                  ? paramsDoctorCategory
                  : paramsCategory
              }
              label="Servizio"
              firstSelect="Seleziona"
            />

            {/* timeslot selection */}
            {pramsTimeslot.length &&
              date &&
              timeslotCategory &&
              filterType === "list" ? (
              <>
                <AutoComplite
                  handleChange={onTimeslotOptionChange}
                  params={pramsTimeslot}
                  selectedOption={timeslotOption}
                  label="Timeslot"
                  firstSelect="Seleziona"
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="col-lg-4 pt-4 text-lg-right">
            <InputSearch
              placeholder={t("search")}
              handleClick={(e: any) => {
                setSearch(e);
              }}
            />
            <ButtonIcon
              handleClick={() => dispatch(changeFilterType("list"))}
              icon="format_list_bulleted"
              active={filterType === "list"}
            />
            <ButtonIcon
              handleClick={() => dispatch(changeFilterType("calendar"))}
              icon="calendar_today"
              active={filterType === "calendar"}
            />
            {!isDoctor &&
              <DropdownIcon
                dropdownItems={[
                  {
                    title: t("schedule-export"),
                    callback: () => {
                      setShowPopUpEmailSchedule(true);
                    },
                  },
                  {
                    title: t("links-public-calendars"),
                    callback: () => {
                      setShowPopUpLnkPublicCalendars(true);
                    },
                  },
                  {
                    title: t("links-televisit"),
                    callback: () => {
                      setShowPopUpLnkTelevisit(true);
                    },
                  },
                ]}
                icon="more_vert"
              />
            }
          </div>
        </div>
      </div>
      {!isDoctor &&
        <>
          <PopUpLinkPublicCalendars
            show={showPopUpLnkPublicCalendars}
            closePopUp={() => {
              setShowPopUpLnkPublicCalendars(false);
            }}
          />
          <PopUpEmailSchedule
            closePopUp={() => {
              setShowPopUpEmailSchedule(false);
            }}
            show={showPopUpEmailSchedule}
          />
          <PopUpLinkTelevisit
            show={showPopUpLnkTelevisit}
            closePopUp={() => {
              setShowPopUpLnkTelevisit(false);
            }}
          />

        </>
      }
    </>
  );
};

export default FilterBox;
